import { TemplateModel } from './template.model';
import { DocumentModel } from '../document/document.model';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { IDocumentContentMediaBankFile, ITemplatePlaceHolderControlContent } from '@fi-app/template/template';
import { FiImageSize } from '@fi-shared/types';
import { LinkToModel } from '@fi-shared/link-to/link-to.model';
import { Injector } from '@angular/core';
import { FiMediaStorageService } from '@fi-shared/media-bank/fi-media-storage.service';

export class TemplateLayoutHelper {
    private existingDocumentMediaReferences: IMediaBankFileReference[];
    private existingTemplateMediaReferences: IMediaBankFileReference[];
    private newMediaReferences: IMediaBankFileReference[] = [];

    constructor(
        template: TemplateModel,
        document: DocumentModel,
        private injector: Injector,
    ) {
        this.existingTemplateMediaReferences = template.MediaBankFileReferences.slice();
        this.existingDocumentMediaReferences = document ? document.MediaBankFileReferences.slice() : [];
    }

    setTemplatePlaceHolderImageContent(
        content: ITemplatePlaceHolderControlContent,
        column: number,
        mediaBankFileReference: IMediaBankFileReference,
    ) {
        const contentFileData = mediaBankFileReference ? this.getContentFileData(mediaBankFileReference) : {};
        if (column === 1) {
            content.Value.File = contentFileData;
        } else {
            content.Value.additionalFile = contentFileData;
        }
        if (mediaBankFileReference) {
            const existingMediaReference = this.findMediaReference(mediaBankFileReference.MediaBankFileId);
            if (!existingMediaReference) {
                this.newMediaReferences.push(mediaBankFileReference);
            }
        }
    }
    deleteTemplatePlaceHolderImageContent(content: ITemplatePlaceHolderControlContent, column: number) {
        this.setTemplatePlaceHolderImageContent(content, column, undefined);
    }

    getContentFileData(mediaBankFile: IMediaBankFileReference): IDocumentContentMediaBankFile {
        const mediaStorageService = this.injector.get(FiMediaStorageService);
        return {
            ChangedOn: mediaBankFile.ChangedOn,
            Extension: mediaBankFile.Extension,
            FileType: mediaBankFile.FileType,
            HideFromMediaBank: mediaBankFile.HideFromMediaBank,
            IsNewUpload: mediaBankFile.IsNewUpload,
            MediaBankFileId: mediaBankFile.MediaBankFileId,
            Name: mediaBankFile.Name,
            PhysicalFileName: mediaBankFile.PhysicalFileName,
            StorageType: mediaBankFile.StorageType,
            Url: mediaStorageService.getMediaFileUrl(mediaBankFile, { size: FiImageSize.Medium }),
            linkTo: new LinkToModel(),
        };
    }

    findMediaReference(mediaBankFileId: number) {
        let item = this.newMediaReferences.find((item) => item.MediaBankFileId == mediaBankFileId);
        if (!item) {
            item = this.existingDocumentMediaReferences.find((item) => item.MediaBankFileId == mediaBankFileId);
        }
        if (!item) {
            item = this.existingTemplateMediaReferences.find((item) => item.MediaBankFileId == mediaBankFileId);
        }
        return item;
    }

    getAllMediaReferences() {
        return this.existingDocumentMediaReferences
            .concat(this.existingTemplateMediaReferences)
            .concat(this.newMediaReferences);
    }
}
